import { useField } from 'formik';
import { PatternTextField, PatternTextFieldProps } from '../PatternTextField';

type Value = string | number | undefined;

interface Props extends Omit<PatternTextFieldProps, 'ref' | 'onChange' | 'type'> {
    name: string;
    defaultValue?: Value;
    value?: Value;
}

export const FormPatternTextField = ({ rows, ...props }: Props) => {
    const [field, meta] = useField(props.name);

    return (
        <PatternTextField
            rows={rows}
            error={meta.touched && Boolean(meta.error)}
            helperText={meta.touched && meta.error}
            {...props}
            {...field}
        />
    );
};
